// Device & Connection Detection Utilities

// Prüfe ob Gerät mobile ist
export const isMobile = () => {
  if (typeof window === 'undefined') return false;

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ) || window.innerWidth < 768;
};

// Prüfe Verbindungsqualität
export const getConnectionQuality = () => {
  if (typeof navigator === 'undefined' || !navigator.connection) {
    // Fallback: Nutze Bildschirmbreite als Indikator
    return window.innerWidth < 768 ? 'slow' : 'fast';
  }

  const connection = navigator.connection;
  const effectiveType = connection.effectiveType;

  // 4g, 3g, 2g, slow-2g
  if (effectiveType === '4g' || effectiveType === 'wifi') {
    return 'fast';
  } else if (effectiveType === '3g') {
    return 'medium';
  } else {
    return 'slow';
  }
};

// Prüfe ob Save-Data Mode aktiv ist
export const isSaveDataMode = () => {
  if (typeof navigator === 'undefined' || !navigator.connection) {
    return false;
  }

  return navigator.connection.saveData === true;
};

// Prüfe verfügbaren Speicher (nur Chrome/Edge)
export const hasLowMemory = () => {
  if (typeof navigator === 'undefined' || !navigator.deviceMemory) {
    // Fallback: Mobile Geräte haben oft weniger Speicher
    return isMobile();
  }

  // deviceMemory in GB - unter 4GB ist "low memory"
  return navigator.deviceMemory < 4;
};

// Kombinierte Funktion: Soll aggressiv preloaden?
export const shouldPreloadAggressively = () => {
  // Nicht aggressiv wenn:
  // - Save Data Mode aktiv
  // - Langsame Verbindung
  // - Wenig Speicher

  if (isSaveDataMode()) {
    return false;
  }

  if (hasLowMemory()) {
    return false;
  }

  const quality = getConnectionQuality();
  if (quality === 'slow') {
    return false;
  }

  return true;
};

// Bestimme maximale parallele Downloads basierend auf Gerät
export const getMaxConcurrentDownloads = () => {
  if (hasLowMemory() || isMobile()) {
    return 3; // Mobile: max 3 parallele Downloads
  }

  const quality = getConnectionQuality();
  if (quality === 'slow') {
    return 2;
  } else if (quality === 'medium') {
    return 4;
  } else {
    return 6; // Desktop/Fast: max 6 parallele Downloads
  }
};

// Debug Info
export const getDeviceInfo = () => {
  return {
    isMobile: isMobile(),
    connectionQuality: getConnectionQuality(),
    saveDataMode: isSaveDataMode(),
    lowMemory: hasLowMemory(),
    shouldPreloadAggressively: shouldPreloadAggressively(),
    maxConcurrent: getMaxConcurrentDownloads(),
    deviceMemory: navigator.deviceMemory || 'unknown',
    effectiveType: navigator.connection?.effectiveType || 'unknown'
  };
};
